const FEEDBACK_CONTAINER = document.querySelector('.feedback-message--container');
if (FEEDBACK_CONTAINER) {
    createFeedbackMsg(false, null);
    showFeedbackMsg();
}

function createFeedbackMsg(api, data) {
    const STATUS = api === true ? data.status : document.querySelector('.feedback-message--container').getAttribute('data-status');
    const MESSAGE = api === true ? data.message : document.querySelector('.feedback-message--container').value;
    const FEEDBACK_WRAP = document.querySelector('.feedback-message--wrap');
    const FEEDBACK_MESSAGE = `<div class="feedback-message ${STATUS}">${MESSAGE}</div>`;
    FEEDBACK_WRAP.innerHTML = FEEDBACK_MESSAGE;
}

function showFeedbackMsg() {
    const FEEDBACK = document.querySelector('.feedback-message--wrap');
    if (FEEDBACK) {
        FEEDBACK.classList.add('fade--item');
        setTimeout(function() {
            FEEDBACK.classList.remove('fade--item');
            FEEDBACK.innerHTML = '';
        }, 5000);
    }
}